import { type Href, router } from "expo-router";

/**
 * Navigates back when the stack has history, otherwise replaces with a safe fallback.
 * Prefer an explicit replace when leaving a root screen of a nested flow (e.g. profile index).
 */
export function goBackOrReplace(fallbackHref: Href = "/family") {
    if (router.canGoBack()) {
        router.back();
        return;
    }

    router.replace(fallbackHref);
}
